import React from 'react';

import PageHero from '../../MyComponents/LandingSections/PageHero';
import FeatureCards from '../../MyComponents/LandingSections/FeatureCards';
import StepsCard from '../../MyComponents/LandingSections/StepsCard';
import HomeProof from '../Home/HomeProof/HomeProof';
import HomeWhy from '../Home/HomeWhy/HomeWhy';
import HomeSchools from '../Home/HomeSchools/HomeSchools';
import HomeFaq from '../Home/HomeFaq/HomeFaq';
import HomeContact from '../Home/HomeContact/HomeContact';
import { featureLinks } from '../../common/features';
import { SPECIAL_QUOTA_LINK, START_FREE_LINK, tutorialLinks } from '../../common/urlLinks';
import { REDESIGN_TINTS } from '../../constants';

const IMG = '/static/asset/img/schools/';

// The before/after pair for a school: the teachers' day, then the school's.
const WHY_CARDS = [
    { key: 'teachers', dark: false, bullets: 3 },
    { key: 'school', dark: true, bullets: 4 },
];

// One card per thing a school gets, in the order a teacher meets them. `more`
// is where "find out more" goes: the tutorial or feature page that shows it.
const FEATURES = [
    // Per language (the lesson on the screens is in the visitor's language); src set in the component.
    {
        key: 'anyBoard',
        src: null,
        tint: REDESIGN_TINTS.mint,
        mediaFirst: true,
        more: tutorialLinks.groups,
        fit: 'cover',
    },
    {
        key: 'prepare',
        src: null,
        tint: REDESIGN_TINTS.amber,
        mediaFirst: false,
        more: tutorialLinks.library,
        fit: 'cover',
    },
    {
        key: 'tools',
        src: null,
        tint: REDESIGN_TINTS.sky,
        mediaFirst: true,
        more: tutorialLinks.generalTools,
        fit: 'cover',
    },
    {
        key: 'history',
        src: null,
        tint: REDESIGN_TINTS.peach,
        mediaFirst: false,
        more: featureLinks.pdfDownload,
        fit: 'cover',
    },
    {
        key: 'hybrid',
        src: null,
        tint: REDESIGN_TINTS.linen,
        mediaFirst: true,
        more: featureLinks.control,
        fit: 'cover',
    },
];

// The five steps the old page listed, each pointing at its tutorial.
const STEPS = [
    { key: 'open', more: tutorialLinks.groups },
    { key: 'classes', more: tutorialLinks.groups },
    { key: 'teach', more: tutorialLinks.generalTools },
    { key: 'library', more: tutorialLinks.library },
    { key: 'share', more: featureLinks.pdfDownload },
];

/**
 * The schools page, composed from the landing's section primitives. The video,
 * proof strip, before/after band, pilot card, FAQ and closing card are the
 * landing's own components pointed at schools copy.
 */
const ForSchools = ({ language }) => {
    // Generated scenes with the app keyed onto the screens, in the visitor's language.
    const SCENES = {
        anyBoard: 'schools-anyboard',
        prepare: 'schools-prepare',
        tools: 'schools-tools',
        history: 'schools-history',
        hybrid: 'schools-hybrid',
    };
    const features = FEATURES.map((feature) =>
        SCENES[feature.key] ? { ...feature, src: `/redesign/${SCENES[feature.key]}.${language}.webp` } : feature
    );

    return (
        <>
            <PageHero
                keyPrefix="redesign.schools.hero"
                primaryTo={SPECIAL_QUOTA_LINK}
                secondaryTo={START_FREE_LINK}
                trust={['anyBoard', 'pilot', 'training']}
                image={{ src: `/redesign/schools-hero.${language}.webp`, width: 1600, height: 900 }}
            />
            <HomeProof />
            <HomeWhy id="de-ce" keyPrefix="redesign.schools.why" cards={WHY_CARDS} />
            <FeatureCards id="functii" keyPrefix="redesign.schools.features" features={features} />
            <StepsCard id="cum-incepe" keyPrefix="redesign.schools.steps" steps={STEPS} />
            <HomeSchools />
            <HomeFaq keyPrefix="redesign.schools.faq" count={5} />
            <HomeContact keyPrefix="redesign.schools.contact" to={SPECIAL_QUOTA_LINK} />
        </>
    );
};

export default ForSchools;
